package com.swetdot.swetgram.protocol.dto

import com.swetdot.swetgram.protocol.Uuid
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** The destination kinds returned by `GET /links/resolve`. */
@Serializable
enum class ResolvedLinkType {
    @SerialName("user_profile") USER_PROFILE,
    @SerialName("public_group") PUBLIC_GROUP,
    @SerialName("private_group_invite") PRIVATE_GROUP_INVITE,
    @SerialName("unknown") UNKNOWN,
}

/** A verified swetgram.com URL translated into stable application routing data. */
@Serializable
data class ResolvedLink(
    @SerialName("type") val type: ResolvedLinkType,
    @SerialName("canonical_url") val canonicalUrl: String,
    @SerialName("fallback_scheme_url") val fallbackSchemeUrl: String? = null,
    @SerialName("target_id") val targetId: Uuid? = null,
    val username: String? = null,
)
